import ResponsiveInitializer from 'ember-responsive/initializers/responsive';
export default ResponsiveInitializer;
